var indexOf = [].indexOf;

angular.module('gym.components').directive('memberMobileAppDetails', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/forms/member_mobile_app_details.html.slim'),
    scope: {
      contact: '=',
      mobileAppSettings: '=',
      reloadMobileAppSettings: '&',
      openMemberMobileAppTab: '&'
    },
    controller: ["$scope", "$stateParams", "$document", "$rootScope", "MobileAppService", function($scope, $stateParams, $document, $rootScope, MobileAppService) {
      var grantMobileAppAccessRequest;
      $scope.accessStatusVisible = function() {
        var ref, ref1;
        return ((ref = $scope.contact.member_mobile_app_details) != null ? ref.enabled : void 0) && ((ref1 = $scope.contact.status) === 'Suspended' || ref1 === 'Cancelled');
      };
      $scope.accessStatus = function() {
        var ref, ref1;
        if (((ref = $scope.contact.member_mobile_app_details) != null ? ref.access_override_policy : void 0) === 'allowed_override') {
          return 'allowed';
        } else {
          return (ref1 = $scope.contact.member_mobile_app_details) != null ? ref1.access_override_policy : void 0;
        }
      };
      $scope.openTab = function() {
        $scope.openMemberMobileAppTab();
        return $scope.$emit('contact:scrollToMainSection');
      };
      $scope.isInvitationAvailable = function() {
        return MobileAppService.isInvitationAvailable($scope.mobileAppSettings);
      };
      $scope.familyMembersStatus = function() {
        var count, familyMembersSetting, membersLabel, ref;
        familyMembersSetting = (ref = $scope.contact.member_mobile_app_details) != null ? ref.family_member_settings : void 0;
        if (!(familyMembersSetting != null ? familyMembersSetting.length : void 0)) {
          return null;
        }
        count = familyMembersSetting.filter(function(item) {
          return item.manageable;
        }).length;
        if (count > 0) {
          membersLabel = count === 1 ? 'member' : 'members';
          return `Manages ${count} family ${membersLabel}`;
        } else {
          return 'Does not manage family members';
        }
      };
      grantMobileAppAccessRequest = function() {
        var mobileAppDetails, params;
        if ($stateParams.mobile_app_access_request_id) {
          mobileAppDetails = $scope.contact.one('mobile_app_details', $scope.contact.member_mobile_app_details.id);
          params = {
            withoutNamespace: true,
            mobile_app_access_request_id: +$stateParams.mobile_app_access_request_id
          };
          return mobileAppDetails.doPUT(params, 'grant_mobile_app_access_request');
        }
      };
      $scope.disabledFeaturesCount = function() {
        var disabledFeatures, features;
        features = $scope.contact.member_mobile_app_details.features_disabled || [];
        disabledFeatures = features.filter(function(feature) {
          return indexOf.call($scope.contact.member_mobile_app_details.features_available_to_gym, feature) >= 0;
        });
        return disabledFeatures.length;
      };
      return $scope.onToggleChange = function() {
        var action, mobileAppDetails, ref;
        if ($scope.mobileAppSettings.mobile_app_invite_quota_exceeded && $scope.contact.member_mobile_app_details.enabled) {
          $scope.contact.member_mobile_app_details = {
            enabled: false
          };
          $scope.openTab();
          return;
        }
        if ((ref = $scope.contact.member_mobile_app_details) != null ? ref.id : void 0) {
          mobileAppDetails = $scope.contact.one('mobile_app_details', $scope.contact.member_mobile_app_details.id);
          action = $scope.contact.member_mobile_app_details.enabled ? mobileAppDetails.doPUT({}, 'enable') : mobileAppDetails.doPUT({}, 'disable');
          return action.then(function() {
            if ($scope.mobileAppSettings.review_status !== 'review_approved') {
              return $scope.reloadMobileAppSettings();
            }
          });
        } else {
          return $scope.contact.all('mobile_app_details').doPOST({}, 'upsert').then(function(response) {
            $scope.contact.member_mobile_app_details = response;
            return grantMobileAppAccessRequest();
          });
        }
      };
    }]
  };
});
